<form *ngIf="formGroup" [formGroup]="formGroup" formFocusable>
  <app-feedback-card [originalModel]="originalModel" [formGroup]="formGroup"></app-feedback-card>

  <app-default-card
    [title]="'Interne Informationen'"
    *ngIf="authorizationService.hasRole('ROLE_EDITOR_BASE')"
    [info]="''">
    <app-internal-information [inputForm]="formGroup"></app-internal-information>
  </app-default-card>

  <app-default-card
    [title]="'Anlagenstandort'"
    [info]="'Anschrift der Anlage'"
    [errorMessage]="'Anschlussadresse ist erforderlich'">
    <app-connection-object
      [areaType]="AreaTypeEnum.POWER"
      [disable]="disableAll$ | async"
      [inputForm]="formGroup"
      (gisDataEvent)="changeGisData($event)"></app-connection-object>
  </app-default-card>

  <app-default-card
    [title]="'Anschlussnehmer (Eigentümer)'"
    [info]="
      'Name und Anschrift der natürlichen oder juristischen Person (z. B. Eigentümer), dessen Kundenanlage unmittelbar über einen Anschluss mit dem Netz des Netzbetreibers verbunden ist.'
    ">
    <app-contact-form
      [formGroup]="formGroup.controls.customer"
      [connectionObjectData]="connectionObjectData$ | async"
      [differsFromCurrentUser]="
        'gridRegistration.customerMailNotInstallerMail' | uiAdaptionVisible : true
      "></app-contact-form>
  </app-default-card>

  <app-default-card
    [title]="'Anschlussnutzer (Anlagenbetreiber)'"
    [info]="
      'Name und Anschrift der natürlichen oder juristischen Person, die im Rahmen eines Anschlussnutzungsverhältnisses einen Anschluss an das Niederspannungsnetz zur allgemeinen Versorgung zur Entnahme oder Einspeisung von elektrischer Energie nutzt.'
    ">
    <form-row>
      <mat-checkbox
        [formControl]="formGroup.controls.differingInvoiceContact"
        (change)="resetDifferingInvoiceContactForm($event.checked)">
        Ist der Anschlussnutzer abweichend vom Anschlussnehmer?
      </mat-checkbox>
    </form-row>
    <app-contact-form
      *ngIf="differingInvoiceContact$ | async"
      [formGroup]="formGroup.controls.invoiceContact"
      [connectionObjectData]="connectionObjectData$ | async"
      [differsFromCurrentUser]="
        'gridRegistration.customerMailNotInstallerMail' | uiAdaptionVisible : true
      "></app-contact-form>
  </app-default-card>

  @if (formGroup.controls.storages.at(0)) {
  <app-default-card [title]="'Speicher'">
    <app-storage-formpart-v2
      [storageForm]="formGroup.controls.storages.at(0)!"
      [consumerForm]="formGroup.controls.consumers.at(0) ?? undefined"
      [producerForm]="formGroup.controls.producers.at(0) ?? undefined"></app-storage-formpart-v2>
  </app-default-card>
  }

  <ng-container *ngIf="formGroup.controls.consumers.at(0)">
    <app-gr-meter-number-formpart
      [formGroup]="formGroup.controls.consumers.at(0)!"
      [hasDefiniteMeter]="false"></app-gr-meter-number-formpart>
  </ng-container>

  <app-default-card
    *ngIf="hasProduction$ | async"
    [title]="'Messkonzept'"
    [info]="'Bitte wählen Sie hier das von Ihnen geplante Messkonzept aus.'"
    [error]="errorFormList.length > 0 && !formGroup.controls.meteringConcept">
    <app-grid-registration-metering-concept-v2
      [displayGroup]="MeteringConceptDisplayGroup.StorageConcepts"
      [disable]="!(canUpdate$ | async)"
      [control]="formGroup.controls.meteringConcept.controls.id"></app-grid-registration-metering-concept-v2>
    <ng-container *ngIf="(showFullFeedInBonusProcess$ | async) && isFullFeedMeteringConcept$ | async">
      <h4 style="margin-top: 2rem">Volleinspeisungsbonus</h4>
      <mat-checkbox [formControl]="formGroup.controls.fullFeedInBonusRequested">
        Ich beantrage die erhöhte Vergütung für Volleinspeisung gemäß § 48 Abs. 2a Satz 1 EEG 2023.
      </mat-checkbox>
    </ng-container>
  </app-default-card>

  <app-default-card [title]="'Wechselrichter'" *ngIf="hasProduction$ | async">
    <app-power-inverter-formpart
      [producerFormArray]="formGroup.controls.producers"
      [gridRegistration]="originalModel"
      [disable]="!(canUpdate$ | async)"></app-power-inverter-formpart>
  </app-default-card>

  <!--
    Die bereits vorhandenen Erzeugungsanlagen stehen ausschließlich in "Weitere Informationen zum
    Netzanschluss" (app-grid-registration-more-info) — dort mit der Checkbox, die die Liste
    aufbaut, wie in der Einspeiser-Netzanmeldung. Eine zweite, eigene Karte hätte dieselbe
    FormArray doppelt angezeigt.
  -->
  <app-default-card
    *ngIf="isAreaTypeAvailableInObjectAddress && !(hideAdditionalGridConnectionPointInformationCard$ | async)"
    [title]="'Weitere Informationen zum Netzanschluss'"
    [info]="'Hier können Sie uns noch weitere wichtigen Informationen zu Ihrem Netzanschluss mitteilen'"
    [showThisComponent]="true"
    [showChildComponent]="true">
    <app-grid-registration-more-info
      [inputForm]="formGroup"
      [gridRegistrationType]="originalModel?.gridRegistrationType"
      [disabledAllFields]="disableAll$ | async"
      [showExistingFeedersCheckbox]="true"
      [inputFormFreeMoreInformation]="formGroup"></app-grid-registration-more-info>
  </app-default-card>

  <app-default-card [title]="'Dokumente'" [info]="''">
    <app-upload-documents
      [inputFormArray]="formGroup.controls.uploads"
      [documentTag]="'uploads'"
      [showTag]="false"
      [canUpdate]="true"
      [filterCriteria]="'equal'"
      [numberOfUploads]="10"
      [editUpload]="true"
      [showUploadButton]="true">
      <div>
        <ng-container
          *ngIf="
            originalModel?.gridRegistrationType &&
              'gridRegistration.' + originalModel.gridRegistrationType + '.documentsUploadInfo'
              | uiAdaptionVisible;
            else defaultTechnicalDocumentsInfo
          ">
          <div
            [innerHTML]="
              'gridRegistration.' + originalModel?.gridRegistrationType + '.documentsUploadInfo'
                | uiAdaptionValue
                | safeHtmlPipe
            "></div>
        </ng-container>
        <ng-template #defaultTechnicalDocumentsInfo>
          <p>
            Relevante technische Dokumentationen.
            <br />
            z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
            Übersichtsschaltplan.
            <br />
          </p>
        </ng-template>
      </div>
    </app-upload-documents>
  </app-default-card>

  <app-default-card [title]="'Bedingungen'" [info]="''">
    <app-accept-conditions
      [inputForm]="formGroup"
      [controlName]="'acceptedConditions1'"
      [inputLink]=""
      [inputText]="'Hiermit bestätige ich, dass die Zustimmung des Eigentümers vorliegt.'">
      <form-row
        *ngIf="
          (powerThresholdReached$ | async) && 'gridRegistration.powerThresholdConditions_30'
            | uiAdaptionValue as conditions
        ">
        <mat-checkbox [formControl]="formGroup.controls.acceptedConditions2">
          <div [innerHTML]="conditions | safeHtmlPipe"></div>
        </mat-checkbox>
      </form-row>
      <mat-error
        *ngIf="
          (powerThresholdReached$ | async) &&
          !formGroup.controls.acceptedConditions2.valid &&
          formGroup.controls.acceptedConditions2.touched
        ">
        Bitte akzeptieren Sie alle Bedingungen
      </mat-error>
    </app-accept-conditions>
    <form-row *ngIf="'gridRegistration.Storage.conditionsCheckbox' | uiAdaptionVisible$ | async">
      <mat-checkbox [formControl]="customConditionsCheckbox" [disabled]="disable">
        <div
          [innerHTML]="'gridRegistration.Storage.conditionsCheckbox' | uiAdaptionValue | safeHtmlPipe"></div>
      </mat-checkbox>
    </form-row>
    <mat-error *ngIf="customConditionsCheckbox.touched && customConditionsCheckbox.invalid">
      Bitte akzeptieren Sie alle Bedingungen
    </mat-error>
  </app-default-card>
</form>
